import cn from "classnames"
import Image from "../Image"
import styles from "./ImagesSection.module.scss"

import Zoom from "react-medium-image-zoom"
import "react-medium-image-zoom/dist/styles.css"
import Section from "../Section"

const ImagesSection = ({ data, colors, content }) => {
  const { full_width, images, image_background_color } = data

  const imageBackgroundColor = image_background_color || "#40454A"

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      colors={colors}
    >
      <div
        className={cn(styles.wrapper, {
          [styles.full]: full_width || images?.length === 1,
          [styles[`imageSection--${content.locale}`]]: content.locale,
        })}
        data-image-count={images.length}
      >
        {images.map((image, i) => (
          <div className={styles.image} key={i}>
            <Zoom wrapStyle={{ display: "block" }}>
              <Image
                src={image.permalink}
                alt={image?.alt}
                height={image.height}
                width={image.width}
                sizes="(max-width: 1199px) 100vw, 1200px"
                style={{
                  objectPosition: image?.focus_css,
                  backgroundColor:
                    content.locale !== "digital" && imageBackgroundColor,
                }}
              />
            </Zoom>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default ImagesSection
